<template>
  <div class="carousel-container" @mouseenter="pause" @mouseleave="resume">
    <div
      class="carousel-wrapper"
      :class="{ paused: isPaused }"
      :style="{
        width: totalWidth + 'px',
        animationDuration: animationDuration + 's'
      }"
    >
      <!-- 原始 items -->
      <div
        v-for="(item, index) in items"
        :key="'orig-' + index"
        class="carousel-item"
      >
        <img :src="item.img" :alt="item.title" class="carousel-img" />
        <h3 class="carousel-title">{{ item.title }}</h3>
        <div class="carousel-desc">{{ item.desc }}</div>
      </div>

      <!-- 无缝复制一份（关键！） -->
      <div
        v-for="(item, index) in items"
        :key="'copy-' + index"
        class="carousel-item"
      >
        <img :src="item.img" :alt="item.title" class="carousel-img" />
        <h3 class="carousel-title">{{ item.title }}</h3>
        <div class="carousel-desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SmoothScrollCarousel",
  props: {
    items: {
      type: Array,
      required: true
    },
    // 滚动一圈所需时间（秒）
    duration: {
      type: Number,
      default: 20
    },
    itemWidth: {
      type: Number,
      default: 280
    },
    gap: {
      type: Number,
      default: 20 // 间距
    }
  },
  data() {
    return {
      isPaused: false
    };
  },
  computed: {
    // 单份 items 的总宽度（含 margin）
    singleWidth() {
      return this.items.length * (this.itemWidth + this.gap) - this.gap;
    },
    // 总宽度 = 两份
    totalWidth() {
      return this.singleWidth * 2;
    },
    // CSS 动画持续时间
    animationDuration() {
      return this.duration;
    }
  },
  methods: {
    pause() {
      this.isPaused = true;
    },
    resume() {
      this.isPaused = false;
    }
  }
};
</script>

<style scoped>
.carousel-container {
  width: 100%;
  /* max-width: 1200px; */
  overflow-x: hidden;
  padding: 0 10px;
  box-sizing: border-box;
}

.carousel-wrapper {
  display: flex;
  height: 450px;
  padding: 30px 0;
  box-sizing: border-box;
  animation: scroll linear infinite;
}

.carousel-wrapper.paused {
  animation-play-state: paused;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.carousel-item {
  width: 280px;
  height: 400px;
  flex-shrink: 0;
  margin-right: 20px;
  border-radius: 12px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: scale(1);
  flex-wrap: wrap;
  color: #7c8294;
}

.carousel-item:hover {
  transform: scale(1.05);
  box-shadow: 0px 0px 14px 0px rgba(87, 87, 87, 0.5);
  z-index: 2;
  position: relative;
  color: #000;
  border: 2px solid #105fff;
}

.carousel-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
}

.carousel-title {
  font-size: 18px;
  font-weight: bold;
  margin: 16px 0;
  color: #333;
}

.carousel-desc {
  font-size: 14px;
  line-height: 30px;
  padding: 0 20px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue